import { render, staticRenderFns } from "./DialogModal.vue?vue&type=template&id=0e18c64c&scoped=true&"
import script from "./DialogModal.vue?vue&type=script&lang=js&"
export * from "./DialogModal.vue?vue&type=script&lang=js&"
import style0 from "./DialogModal.vue?vue&type=style&index=0&id=0e18c64c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e18c64c",
  null
  
)

export default component.exports